(function () {
  var root = document.getElementById('valmaQuiz');
  if (!root) return;

  var PRODUCT_URL = root.dataset.productUrl;
  var PRODUCT_IMAGE = root.dataset.productImage;

  var stage = document.getElementById('quizStage');
  var backBtn = document.getElementById('quizBackBtn');
  var progressWrap = document.getElementById('quizProgressWrap');
  var progressLabel = document.getElementById('quizProgressLabel');
  var progressFill = document.getElementById('quizProgressFill');

  var TOTAL_QUESTIONS = 8;

  var QUESTIONS = [
    {
      id: 'age',
      number: 1,
      question: '¿Qué edad tiene tu hijo?',
      type: 'choice',
      options: [
        { label: '3 - 6 años', weights: {} },
        { label: '7 - 9 años', weights: {} },
        { label: '10 - 12 años', weights: {} },
        { label: '13 años o más', weights: {} }
      ]
    },
    {
      id: 'main_challenge',
      number: 2,
      question: '¿Cuál de estas situaciones describe mejor su día a día?',
      type: 'choice',
      options: [
        { label: 'Le cuesta mantenerse concentrado en una tarea', weights: { focus: 2 } },
        { label: 'Se distrae fácilmente', weights: { focus: 2 } },
        { label: 'Le cuesta relajarse o quedarse tranquilo', weights: { calm: 2 } },
        { label: 'Tiene cambios de humor frecuentes', weights: { calm: 1, general: 1 } },
        { label: 'Le cuesta mantener una buena rutina de descanso', weights: { sleep: 2 } },
        { label: 'Un poco de todo', weights: { focus: 1, calm: 1, sleep: 1, general: 1 } }
      ]
    },
    {
      id: 'homework',
      number: 3,
      question: '¿Cómo suelen ser los momentos de tarea?',
      type: 'choice',
      options: [
        { label: 'Se concentra y las hace sin demasiados problemas', weights: {} },
        { label: 'Necesita varios recordatorios para continuar', weights: { focus: 2 } },
        { label: 'Se distrae constantemente', weights: { focus: 2 } },
        { label: 'Se frustra rápidamente', weights: { calm: 2 } },
        { label: 'Las tareas suelen terminar en discusiones', weights: { calm: 1, general: 1 } },
        { label: 'Es diferente cada día', weights: { general: 2 } }
      ]
    },
    {
      id: 'mornings',
      number: 4,
      question: '¿Cómo son normalmente las mañanas antes de ir al colegio?',
      type: 'choice',
      options: [
        { label: 'Tranquilas', weights: {} },
        { label: 'Algo difíciles', weights: { general: 1 } },
        { label: 'Necesita muchos recordatorios', weights: { focus: 2 } },
        { label: 'Suele estar irritable o frustrado', weights: { calm: 2 } },
        { label: 'Son bastante caóticas', weights: { general: 2, sleep: 1 } }
      ]
    },
    {
      id: 'concentration',
      number: 5,
      question: 'Cuando necesita concentrarse durante una actividad, ¿qué suele ocurrir?',
      type: 'choice',
      options: [
        { label: 'Puede concentrarse durante bastante tiempo', weights: {} },
        { label: 'Necesita algunos descansos', weights: { focus: 1 } },
        { label: 'Se distrae muy fácilmente', weights: { focus: 2 } },
        { label: 'Le cuesta terminar lo que empieza', weights: { focus: 2 } },
        { label: 'Se frustra antes de terminar', weights: { calm: 1, focus: 1 } }
      ]
    },
    {
      id: 'calm_after_day',
      number: 6,
      question: 'Después de un día largo, ¿qué tan fácil le resulta relajarse?',
      type: 'choice',
      options: [
        { label: 'Muy fácil', weights: {} },
        { label: 'Bastante fácil', weights: {} },
        { label: 'A veces le cuesta', weights: { calm: 1 } },
        { label: 'Le cuesta bastante', weights: { calm: 2 } },
        { label: 'Le cuesta mucho', weights: { calm: 2, sleep: 1 } }
      ]
    },
    {
      id: 'family_impact',
      number: 7,
      question: '¿En qué medida estas situaciones afectan la rutina familiar?',
      type: 'scale',
      minLabel: 'Muy poco',
      maxLabel: 'Muchísimo'
    },
    {
      id: 'goal',
      number: 8,
      question: 'Si pudieras mejorar UNA cosa de su rutina durante las próximas semanas, ¿cuál elegirías?',
      type: 'choice',
      options: [
        { label: 'Mejor concentración', weights: { focus: 3 } },
        { label: 'Más enfoque durante las tareas', weights: { focus: 3 } },
        { label: 'Mayor calma', weights: { calm: 3 } },
        { label: 'Mejor rutina de descanso', weights: { sleep: 3 } },
        { label: 'Mayor bienestar emocional', weights: { general: 2, calm: 1 } },
        { label: 'Una combinación de todas', weights: { general: 3 } }
      ]
    }
  ];

  var RESULTS = {
    focus: {
      title: 'El enfoque parece ser una de las principales necesidades de su rutina.',
      paragraphs: [
        'Por las respuestas que nos diste, parece que los momentos que requieren concentración —como las tareas o actividades escolares— son uno de los principales desafíos de su día a día.',
        'Por eso, una rutina enfocada en acompañar el enfoque y la concentración puede ser un buen punto de partida.'
      ],
      blurb: 'Valma Nüva combina azafrán con otros ingredientes seleccionados para acompañar una rutina orientada al enfoque, la calma y el bienestar.',
      event: 'quiz_result_focus'
    },
    calm: {
      title: 'La calma parece ser una de las principales necesidades de su rutina.',
      paragraphs: [
        'Según tus respuestas, los momentos de frustración, irritabilidad o dificultad para relajarse aparecen con frecuencia.',
        'Una rutina consistente, sostenida día a día, puede ayudar a acompañar esos momentos.'
      ],
      blurb: 'Valma Nüva combina azafrán con otros ingredientes seleccionados para acompañar una rutina orientada al enfoque, la calma y el bienestar.',
      event: 'quiz_result_calm'
    },
    sleep: {
      title: 'El descanso parece ser un área importante para trabajar.',
      paragraphs: [
        'Por tus respuestas, parece que relajarse y mantener una buena rutina de descanso puede ser uno de los principales desafíos.',
        'Sumar hábitos simples y constantes alrededor del descanso suele ser un buen punto de partida.'
      ],
      blurb: 'Valma Nüva puede ser un complemento prudente dentro de una rutina de bienestar orientada a acompañar el descanso y la calma.',
      event: 'quiz_result_sleep'
    },
    general: {
      title: 'Buscás acompañar varios aspectos de su rutina.',
      paragraphs: [
        'Por tus respuestas, no hay un único desafío predominante. Parece que buscás una solución que acompañe el enfoque, la calma y el bienestar general.'
      ],
      blurb: 'Valma Nüva combina azafrán con otros ingredientes seleccionados para acompañar una rutina orientada al enfoque, la calma y el bienestar.',
      event: 'quiz_result_general'
    }
  };

  var state = {
    index: 0,
    answers: {},
    scores: { focus: 0, calm: 0, sleep: 0, general: 0 }
  };

  function trackEvent(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data || {}));
    if (window.console && window.console.info) {
      console.info('[valma_quiz]', name, data || {});
    }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function updateProgress() {
    var current = Math.min(state.index + 1, TOTAL_QUESTIONS);
    var pct = (current / TOTAL_QUESTIONS) * 100;
    progressLabel.textContent = 'Pregunta ' + current + ' de ' + TOTAL_QUESTIONS;
    progressFill.style.width = pct + '%';
  }

  function buildOptionsHtml(q) {
    return q.options
      .map(function (opt, i) {
        var selected = state.answers[q.id] && state.answers[q.id].label === opt.label;
        return (
          '<button type="button" class="quiz-option' + (selected ? ' is-selected' : '') + '" data-index="' + i + '">' +
          '<span>' + escapeHtml(opt.label) + '</span>' +
          '<svg class="quiz-option-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 13l4 4L19 7"/></svg>' +
          '</button>'
        );
      })
      .join('');
  }

  function buildScaleHtml(q) {
    var current = state.answers[q.id] ? state.answers[q.id].value : null;
    var cells = '';
    for (var v = 1; v <= 10; v++) {
      cells += '<button type="button" class="quiz-scale-cell' + (current === v ? ' is-selected' : '') + '" data-value="' + v + '">' + v + '</button>';
    }
    return (
      '<div class="quiz-scale">' +
      '<div class="quiz-scale-row">' + cells + '</div>' +
      '<div class="quiz-scale-labels"><span>' + q.minLabel + '</span><span>' + q.maxLabel + '</span></div>' +
      '</div>'
    );
  }

  function questionHtml(q) {
    var body = q.type === 'scale' ? buildScaleHtml(q) : '<div class="quiz-options">' + buildOptionsHtml(q) + '</div>';
    return (
      '<div class="quiz-question-inner">' +
      '<h2 class="quiz-question-title">' + escapeHtml(q.question) + '</h2>' +
      body +
      '</div>'
    );
  }

  function attachQuestionHandlers(q) {
    var el = stage.querySelector('.quiz-question-inner');
    if (!el) return;
    if (q.type === 'scale') {
      var cells = el.querySelectorAll('.quiz-scale-cell');
      cells.forEach(function (cell) {
        cell.addEventListener('click', function () {
          selectScale(q, parseInt(cell.dataset.value, 10));
        });
      });
    } else {
      var opts = el.querySelectorAll('.quiz-option');
      opts.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectOption(q, q.options[parseInt(btn.dataset.index, 10)]);
        });
      });
    }
  }

  function applyWeights(weights) {
    Object.keys(weights || {}).forEach(function (k) {
      state.scores[k] = (state.scores[k] || 0) + weights[k];
    });
  }

  function removeWeights(weights) {
    Object.keys(weights || {}).forEach(function (k) {
      state.scores[k] = (state.scores[k] || 0) - weights[k];
    });
  }

  function selectOption(q, opt) {
    var prev = state.answers[q.id];
    if (prev && prev.weights) removeWeights(prev.weights);
    state.answers[q.id] = { label: opt.label, weights: opt.weights };
    applyWeights(opt.weights);
    trackEvent('quiz_question_answered', { question_id: q.id, question_number: q.number, answer: opt.label });
    goNext();
  }

  function selectScale(q, value) {
    var prev = state.answers[q.id];
    if (prev && prev.weights) removeWeights(prev.weights);
    var weights = value >= 7 ? { general: 2 } : value >= 4 ? { general: 1 } : {};
    state.answers[q.id] = { value: value, label: String(value), weights: weights };
    applyWeights(weights);
    trackEvent('quiz_question_answered', { question_id: q.id, question_number: q.number, answer: value });
    goNext();
  }

  function goNext() {
    if (state.index < QUESTIONS.length - 1) {
      state.index += 1;
      renderStep('forward');
    } else {
      trackEvent('quiz_completed', { answers: summarizeAnswers() });
      renderProcessing();
    }
  }

  function goBack() {
    if (state.index > 0) {
      state.index -= 1;
      renderStep('backward');
    }
  }

  function summarizeAnswers() {
    var out = {};
    Object.keys(state.answers).forEach(function (id) {
      out[id] = state.answers[id].label;
    });
    return out;
  }

  function transitionTo(html, direction, afterRender) {
    var old = stage.firstElementChild;
    var exitClass = direction === 'backward' ? 'quiz-exit-right' : 'quiz-exit-left';
    var enterStartClass = direction === 'backward' ? 'quiz-enter-left' : 'quiz-enter-right';

    function mount() {
      stage.innerHTML = html;
      var el = stage.firstElementChild;
      if (el) {
        el.classList.add(enterStartClass);
        void el.offsetWidth;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.classList.remove(enterStartClass);
            el.classList.add('quiz-enter-active');
          });
        });
      }
      if (afterRender) afterRender();
    }

    if (old) {
      old.classList.add(exitClass);
      setTimeout(mount, 220);
    } else {
      mount();
    }
  }

  function renderStep(direction) {
    var q = QUESTIONS[state.index];
    updateProgress();
    backBtn.classList.toggle('is-hidden', state.index === 0);
    progressWrap.classList.remove('is-hidden');
    transitionTo(questionHtml(q), direction, function () {
      attachQuestionHandlers(q);
    });
  }

  function renderProcessing() {
    backBtn.classList.add('is-hidden');
    progressWrap.classList.add('is-hidden');
    var html =
      '<div class="quiz-processing-inner">' +
      '<div class="quiz-processing-spinner"></div>' +
      '<p class="quiz-processing-text" id="quizProcessingText">Analizando tus respuestas…</p>' +
      '</div>';
    transitionTo(html, 'forward', function () {
      var text = document.getElementById('quizProcessingText');
      setTimeout(function () {
        if (text) text.textContent = 'Tenemos una recomendación para vos.';
      }, 1150);
      setTimeout(renderResult, 2000);
    });
  }

  function computeResultKey() {
    var scores = state.scores;
    var keys = ['focus', 'calm', 'sleep', 'general'];
    var max = Math.max.apply(null, keys.map(function (k) { return scores[k] || 0; }));
    var top = keys.filter(function (k) { return (scores[k] || 0) === max; });
    if (max <= 0 || top.length > 1) return 'general';
    return top[0];
  }

  function renderResult() {
    var key = computeResultKey();
    var result = RESULTS[key];

    var html =
      '<div class="quiz-result-inner">' +
      '<span class="quiz-eyebrow">Tenemos una recomendación para vos</span>' +
      '<h2 class="quiz-result-title">' + escapeHtml(result.title) + '</h2>' +
      result.paragraphs.map(function (p) { return '<p class="quiz-result-text">' + escapeHtml(p) + '</p>'; }).join('') +
      '<p class="quiz-result-text quiz-result-product-blurb">' + escapeHtml(result.blurb) + '</p>' +
      '<a href="' + PRODUCT_URL + '" class="btn btn-primary quiz-result-cta" id="quizCtaPrimary">CONOCER VALMA NÜVA</a>' +
      '<div class="quiz-product-card">' +
      '<img src="' + PRODUCT_IMAGE + '" alt="Valma Nüva, gomitas con azafrán" loading="lazy">' +
      '<div class="quiz-product-body">' +
      '<span class="quiz-product-eyebrow">Valma Nüva</span>' +
      '<h3>Gomitas con azafrán</h3>' +
      '<ul class="quiz-product-tags"><li>Enfoque diario</li><li>Calma natural</li><li>Bienestar integral</li></ul>' +
      '<a href="' + PRODUCT_URL + '" class="btn btn-ghost quiz-product-cta" id="quizCtaSecondary">VER VALMA NÜVA</a>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="quiz-restart" id="quizRestartBtn">Rehacer el quiz</button>' +
      '</div>';

    transitionTo(html, 'forward', function () {
      trackEvent(result.event, { result: key, scores: state.scores });
      ['quizCtaPrimary', 'quizCtaSecondary'].forEach(function (id) {
        var btn = document.getElementById(id);
        if (btn) {
          btn.addEventListener('click', function () {
            trackEvent('quiz_product_click', { result: key, cta: id });
          });
        }
      });
      var restart = document.getElementById('quizRestartBtn');
      if (restart) restart.addEventListener('click', restartQuiz);
    });
  }

  function restartQuiz() {
    state.index = 0;
    state.answers = {};
    state.scores = { focus: 0, calm: 0, sleep: 0, general: 0 };
    trackEvent('quiz_started', { restarted: true });
    renderStep('forward');
  }

  backBtn.addEventListener('click', goBack);

  trackEvent('quiz_started', { restarted: false });
  renderStep('forward');
})();
